


































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PriceView extends Vue {
  public items: Common.Price[] = new Array(0);
  public params: Common.PriceQuery = new Common.PriceQuery();
  public importQuery = new Common.PriceImportQuery('単価');
  public exportQuery = new Common.PriceExportQuery('単価', this.params);
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseCurrency: boolean = false;
  @Prop() public auditNo:string;
  @Prop() public commodityCode:string;
  @Prop() public commodity:Common.Commodity;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([], 6, 'grid');


  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'commodity', text: '商品' },
    { value: 'tax', text: '税区分' },
    { value: 'counterpartPriceCategory', text: '取引先単価区分' },
    { value: 'startDate', text: '価格改定日' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    //テナント設定をロードする
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('ID', 100),
      new Common.GridItemConfiguration('商品コード', 150),      
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('メーカー', 100),      
      new Common.GridItemConfiguration('型番', 100),       
      new Common.GridItemConfiguration('単価区分', 100),
      new Common.GridItemConfiguration('通貨', 80,this.hasLicenseCurrency),          
      new Common.GridItemConfiguration('標準単価', 120),
      new Common.GridItemConfiguration('単位', 100),
      new Common.GridItemConfiguration('税区分', 100),      
      new Common.GridItemConfiguration('取引先', 120),
      new Common.GridItemConfiguration('取引先単価区分', 120),
      new Common.GridItemConfiguration('価格改定日', 120),      
      // new Common.GridItemConfiguration('商品コード', 150),      
      // new Common.GridItemConfiguration('適用数量1', 150),
      // new Common.GridItemConfiguration('適用単価1', 150),
      // new Common.GridItemConfiguration('適用数量2', 150),
      // new Common.GridItemConfiguration('適用単価2', 150),
      // new Common.GridItemConfiguration('適用数量3', 150),
      // new Common.GridItemConfiguration('適用単価3', 150),
      // new Common.GridItemConfiguration('適用数量4', 150),
      // new Common.GridItemConfiguration('適用単価4', 150),
      // new Common.GridItemConfiguration('適用数量5', 150),
      // new Common.GridItemConfiguration('適用単価5', 150),
      // new Common.GridItemConfiguration('適用数量6', 150),
      // new Common.GridItemConfiguration('適用単価6', 150),
      // new Common.GridItemConfiguration('適用数量7', 150),
      // new Common.GridItemConfiguration('適用単価7', 150),
      // new Common.GridItemConfiguration('適用数量8', 150),
      // new Common.GridItemConfiguration('適用単価8', 150),
      // new Common.GridItemConfiguration('適用数量9', 150),
      // new Common.GridItemConfiguration('適用単価9', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );


    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }
      
    if (this.commodity){
      this.params.commodity = this.commodity;
    }
    if(!this.auditNo && !this.commodity) {
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}    
    this.$api.formatter.ensureListLoaded('workflow_masterBase','taxCode');                
  }
  public async onCreate(obj: Common.Price) {
    if(this.params != null && this.params.priceType != null && this.params.priceType != Common.PriceTypes.None) obj.priceType = this.params.priceType;
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.currency = this.tenantSettings.currencyCode;
    if (this.popup && this.commodity) obj.commodity = this.commodity;        
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Price):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public enabledPrice(no:number, item:Common.Price):boolean{
    if(no >= 1 && item.minimumQuantity1 == 0) return false;
    if(no >= 2 && item.minimumQuantity2 == 0) return false;
    if(no >= 3 && item.minimumQuantity3 == 0) return false;
    if(no >= 4 && item.minimumQuantity4 == 0) return false;
    if(no >= 5 && item.minimumQuantity5 == 0) return false;
    if(no >= 6 && item.minimumQuantity6 == 0) return false;
    if(no >= 7 && item.minimumQuantity7 == 0) return false;
    if(no >= 8 && item.minimumQuantity8 == 0) return false;
    if(no >= 9 && item.minimumQuantity9 == 0) return false;
    return true;
  }
  public checkPriceType(item:Common.Price)
  {
    // const item = (this.$refs.mainList as Components.ListView).selected as Common.Price;
    // 商品の販売単価区分が「販売単価掛率」で販売単価が入力された場合、設定が反映されない警告メッセージを出力する
    if(item.priceType==Common.PriceTypes.SalesPlice && item.commodity && item.commodity.priceType!=Common.SalesPricingTypes.PriceMaster){
      this.$api.modal.showDialog('メッセージ','単価マスタの販売単価を有効にするには、指定した商品の販売単価区分を「単価マスタ」に設定してください。',true);
    }
    if(item.priceType==Common.PriceTypes.SalesPlice && item.counterpart.counterpartType!=Common.CounterpartTypes.Customer) item.counterpart = null;
    if(item.priceType==Common.PriceTypes.PurchasePrice && item.counterpart.counterpartType!=Common.CounterpartTypes.Supplier) item.counterpart = null;
  }
}
